var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100 footer"},[_c('div',{staticClass:"w120 mc font-16 flex-box",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"mr20 flex-1"},[_vm._v("版权信息："+_vm._s(_vm.copyrightInfo || '桂ICP备14004231'))])])])}
var staticRenderFns = []

export { render, staticRenderFns }